<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    value: Date | number | string | undefined | null
    mode?: "long" | "short" | "time"
  }>(),
  { mode: "long" },
)

const content = computed<string>(() => {
  if (R.isNullish(props.value)) {
    return ""
  }

  let timestamp: Date
  if (R.isString(props.value)) {
    timestamp = dt.parseISO(props.value)
  } else if (R.isNumber(props.value)) {
    timestamp = new Date(props.value)
  } else {
    timestamp = props.value
  }

  if (props.mode === "time") {
    return dt.format(timestamp, "HH:mm")
  }

  return displayDate(timestamp, props.mode === "long")
})
</script>

<template>
  <span>{{ content }}</span>
</template>
